import { Button, Row, Col, Container, Modal } from "react-bootstrap";
import Select from "react-select";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import { useState } from "react";
import HandleHttpErrors from "../../components/HandleHttpErrors";
import { useLocation, useNavigate } from "react-router-dom";
import GetParsedDate from "../../components/shared/GetParsedDate";
import { FaEye, FaEyeSlash } from "react-icons/fa"; // Optional: Font Awesome for icons

const baseURL = process.env.REACT_APP_API;
const EMAIL_REGEX = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
const PWD_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%]).{8,24}$/;

const EditModal = ({
  showEdit,
  setShowEdit,
  user,
  increment,
  setUserId,
  optionList,
}) => {
  const [passwordVisible, setPasswordVisible] = useState(false);
  const header = "עדכון פרטי המשתמש";
  const [user1, setUser1] = useState({
    ...user,
    userGroupsChanged: false,
    action: "updateOther",
    passWord: "",
  });
  const [error, setError] = useState(false);
  const [userGroups, setUserGroups] = useState(
    user?.groups?.map((item) => ({
      value: item.name,
      label: item.name.charAt(0).toUpperCase() + item.name.slice(1),
    }))
  );
  const axiosPrivate = useAxiosPrivate("application/json");
  const navigate = useNavigate();
  const location = useLocation();
  const handleChange = (e) => {
    e.preventDefault();
    const { name, value } = e.target;
    setUser1((prevState) => ({
      ...prevState,
      [name]: value.replace(/\s+/g, ""),
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let isMounted = true;
    const validEmail = EMAIL_REGEX.test(user1.email);
    const validPwd =
      PWD_REGEX.test(user1.passWord) || user1.passWord.length == 0;
    const controller = new AbortController();
    const saveData = async () => {
      try {
        const response = await axiosPrivate.put(
          baseURL + "accounts/updateuser/" + user1.id + "/",
          user1,
          {
            signal: controller.signal,
          }
        );
        isMounted && increment();
      } catch (err) {
        if (err.response) {
          if (err.response.status === 500) {
            alert("אינך מורשה לבצע פעולה זו!");
          }
          if (err.response.status === 401) {
            navigate("/login", { state: { from: location }, replace: true });
          } else if (err.response.status === 403) {
            alert("2", HandleHttpErrors(err.response.status));
          }
          console.log(err.response);
        } else if (err.request) {
          alert(
            " The client never received a response, and the request was never left"
          );
          console.log(err.request);
        } else {
          console.log(err);
          alert(" Anything else");
        }
      }
    };
    if (validEmail && validPwd) {
      saveData();
      setUserId(null);
      setError(false);
    } else if (!validEmail) {
      alert("כתובת דואר אלקטרוני אינה תקינה");
    } else alert("הסיסמה אינה עומדת בדרישות.");
  };
  function handleSelect(data) {
    setUserGroups(data);
    setUser1((prevState) => ({
      ...prevState,
      userGroupsChanged: true,
      ["newGroups"]: data.map((group) => ({
        name: group.value.charAt(0).toLowerCase() + group.value.slice(1),
      })),
    }));
  }
  return (
    <>
      <Modal
        show={showEdit}
        onHide={() => setShowEdit(false)}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton={false}>
          <Modal.Title className="modal-title-center">
            {"מספר המשתמש" + " " + user1.id}
            <br />
            {header + " " + user1.username} <br />
            <h6>
              {"תאריך הצטרפות:" + " "}{" "}
              <GetParsedDate strDate={user1.date_joined} withTime={true} />
              <br />
              {"כניסה אחרונה:" + " "}{" "}
              <GetParsedDate strDate={user1.last_login} withTime={true} />
            </h6>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form>
            <Container>
              <Row>
                <Col>
                  <label>קבוצות ההרשאה</label>
                  <div className="dropdown-container">
                    <Select
                      options={optionList}
                      placeholder="בחר סיבות"
                      value={userGroups}
                      onChange={handleSelect}
                      isSearchable={true}
                      isMulti
                    />
                  </div>
                </Col>
              </Row>
              <Row>
                <Col>
                  <div className="form-group">
                    <label>דואר אלקטרוני</label>
                    <input
                      name="email"
                      className="form-control"
                      id="email"
                      value={user1.email}
                      onChange={handleChange}
                    />
                  </div>
                </Col>
              </Row>
              <Row>
                <Col>
                  <div className="form-group">
                    <div
                      className="password-input"
                      style={{
                        position: "relative",
                        display: "inline-block",
                        width: "100%",
                      }}
                    >
                      <label>סיסמה</label>
                      <input
                        type={passwordVisible ? "text" : "password"}
                        name="passWord"
                        className="form-control"
                        id="passWord"
                        value={user1.passWord}
                        onChange={handleChange}
                        style={{
                          paddingRight: "40px", // Space for the icon
                          direction: "ltr", // Ensures the text starts from the left
                          textAlign: "left", // Aligns the text to the left
                        }}
                      />
                      <span
                        onClick={() => setPasswordVisible(!passwordVisible)}
                        style={{
                          position: "absolute",
                          top: "70%", // Align to the middle vertically
                          right: "10px", // Align near the right edge
                          transform: "translateY(-70%)", // Center vertically
                          cursor: "pointer",
                        }}
                      >
                        {passwordVisible ? <FaEyeSlash /> : <FaEye />}
                      </span>
                    </div>
                    <p className="password-hint">
                      מ 8 עד 24 תוים.
                      <br />
                      צריך להכיל אותיות גדולות וקטנות באנגלית, מספרים ותו מיוחד.
                      <br />
                      תוים מיוחדים מותרים:{" "}
                      <span aria-label="exclamation mark">!</span>{" "}
                      <span aria-label="at symbol">@</span>{" "}
                      <span aria-label="hashtag">#</span>{" "}
                      <span aria-label="dollar sign">$</span>{" "}
                      <span aria-label="percent">%</span>
                    </p>
                  </div>
                </Col>
              </Row>
              <Row>
                <div className="col-lg-6">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={handleSubmit}
                  >
                    שמירה
                  </button>
                </div>
                <div className="col-lg-3"></div>
                <div className="col-lg-3">
                  <Button
                    variant="secondary"
                    onClick={() => {
                      increment();
                      setShowEdit(false);
                      setUserId(null);
                    }}
                  >
                    סגירה
                  </Button>
                </div>
              </Row>
            </Container>
          </form>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default EditModal;
